import DataTable from "../../components/DataTable/DataTable";
import {useState} from "react";
import http from "../../http";
import {Button, message, Space, Tooltip, Typography} from "antd";
import APIEventAddPage from "./APIEventAddPage";
import {EditOutlined, PlusOutlined} from "@ant-design/icons";


const APIEventListPage = () => {
    const [showModal, setShowModal] = useState(false);
    const [reload, setReload] = useState(false);
    const [edit, setEdit] = useState(false);
    const [item, setItem] = useState(false);
    const handleOpenModal = (item, edit) => {
        if(edit){
            setEdit(true);
            setItem(item);
            setShowModal(true);
        }
        else {
            setEdit(false);
            setItem(null);
            setShowModal(true);

        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setEdit(false);
        setItem(null);
    };
    const handleSuccessAdd = () =>{
        setShowModal(false);
        setEdit(false);
        setItem(null);
        setReload(!reload);
    }

    const handleDeleteClick = (item)=>{
        http.delete(`/api/v1/api_service/api_events/${item.id}/delete/`).then((resp)=>{
            setReload(!reload);
        }).catch((err)=>{
            if(err.response){
                message.error(err.response.data.message);
            }
        })
    }
    const renderEditIcon=(record)=>{
        // if(!record.status){
            return <Typography.Link onClick={()=>handleOpenModal(record, true)}><EditOutlined /></Typography.Link>
        // }
        // return <Typography.Link style={{color:'grey'}} onClick={()=>message.error('Can\'t be edited this item')}><EditOutlined /></Typography.Link>
    }
    const columns = [
        {
            title: 'Event',
            dataIndex: 'name',
            key: 'event_name',
            width: '12%'
        },
        {
            title: 'Server',
            dataIndex: 'server_text',
            key: 'server_name',
            width: '12%',
        },
        {
            title: 'Request Method',
            dataIndex: 'request_method',
            key: 'request_method',
            width: '12%',
        },
        {
            title: 'Request Mapping',
            dataIndex: 'request_mapping',
            key: 'request_mapping',
            render: (text) => (
                     <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>{text? JSON.stringify(text): ''}</div>
             ),
            width: '12%',
        },
        {
            title: 'Response Mapping',
            dataIndex: 'response_mapping',
            key: 'response_mapping',
            render: (text) => (
                     <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>{text? JSON.stringify(text): ''}</div>
             ),
            width: '12%',
        },
        {
            title: 'Endpoint',
            dataIndex: 'url',
            key: 'url',
            width: '16%',
        },
        // {
        //     title: 'Client ID',
        //     dataIndex: 'client_id',
        //     key: 'client_id',
        //     width: 100,
        //     ellipsis: true,
        //     render: (text) => (
        //         <Tooltip title={text} placement={'leftTop'}>
        //             <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>{text}</div>
        //         </Tooltip>
        //     ),
        // },
        // {
        //     title: 'Client Secret',
        //     dataIndex: 'client_secret',
        //     key: 'client_secret',
        //     width: 100,
        //     ellipsis: true,
        //     render: (text) => (
        //         <Tooltip title={text} placement={'leftTop'}>
        //             <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>{text}</div>
        //         </Tooltip>
        //     ),
        // },
        {
            title: 'Background',
            dataIndex: 'is_background',
            key: 'is_background',
            width: '12%',
        },
        {
            title: 'Action',
            key: 'action',
            fixed:'right',
            width: '12%',
            align: 'center',
            render: (record) => (
                <Space size="middle">
                    {renderEditIcon(record)}
                </Space>
            )
        },
    ];

    const searchFields = [
        {
            name: 'name',
            type: 'input',
            label: 'Name',
            placeholder: 'Server Name'
        }
    ];

    const data = [
        // Provide your table data if not using URL
    ];

    return (
        <>
            <DataTable
                reload={reload}
                pageTitle={'API Events'}
                columns={columns}
                url="/api/v1/api_service/api_events/"
                searchFields={searchFields}
                pagination={true}
                pageButtons={[
                    <Button
                        type="primary"
                        shape={'circle'}
                        icon={<PlusOutlined/>}
                        style={{marginLeft: 16, background:'#377EF3'}}
                        onClick={()=>handleOpenModal()}
                    />
                ]}
            />
            <APIEventAddPage
                visible={showModal}
                onClose={handleCloseModal}
                onSuccessSubmit={handleSuccessAdd}
                edit={edit}
                editItem={item}
                reload={reload}
            />
        </>
    );
};

export default APIEventListPage;